import React, { useState } from 'react';
import styled from 'styled-components';
import { CommonStyledComponentProps } from '__utils/type';



export const SipLumpsumTitle = styled.div<CommonStyledComponentProps>`
    text-align: ${(props: any) => props.isMobile ? 'center' : 'left'};
    h3{
        font-size: ${(props: any) => props.isMobile ? '18px' : '32px'};
    }
    p{
        font-size: ${(props: any) => props.isMobile ? '14px' : '16px'};
    }
    span{
        font-size: ${(props: any) => props.isMobile ? '12px' : '14px'};
        color: #3B413E;
        margin-top: 10px;
    }  
`;

export const CalculatorDisclaimer: React.FC = () => {
    const [showReadMore, setShowReadMore] = useState<boolean>(false);
    return <div className='disclaimerBg'>
        <p>
            Disclaimer: This calculator is meant to be used for indicative purposes only. It is designed to assist you in determining the appropriate amount of prospective investments.&nbsp;
            {showReadMore && <span>This calculator alone is not sufficient and shouldn’t be used for the development or implementation of any investment strategy. Turtlemint mutual fund distributor private Limited does not take the responsibility/liability nor does it undertake the authenticity of the figures calculated therein. Turtlemint mutual fund distributor private Limited makes no warranty about the accuracy of the calculators/reckoners. The examples do not claim to represent the performance of any security or investments. In view of the individual nature of tax consequences, each investor is advised to consult his/her own professional tax advisor before making any investment decisions on the basis of the results provided through the use of this calculator. Mutual Funds do not have a fixed rate of return and it is not possible to predict the rate of return.&nbsp;</span>}
            <span className="readMoreBold" onClick={() => setShowReadMore(prevState => !prevState)}>{showReadMore ? 'Read Less' : 'Read More'}</span>
        </p>
    </div>
}
